import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-swifter',
  templateUrl: './swifter.component.html',
  styleUrls: ['./swifter.component.css']
})
export class SwifterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
